import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// 3rd party imports
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';

// Model Imports
import { PropertyCommunityInfoParameterDto } from '../../_models/property-community-info-parameter-dto';
import { PropertyCommunityInfoResultDto } from '../../_models/property-community-info-result-dto';

// Service imports
import { MPCacheRegistrationService } from '../shared-services/mp-cache-registration-service';

// constants imports
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';
import { UserInfoResultDto } from '../../_models/user-info-result-dto';

@Injectable({
    providedIn: 'root'
})
export class ContextManagerService {
    private readonly _subjectContext: Subject<PropertyCommunityInfoResultDto> = new Subject();

    private _selectedContextRouteItem: string;
    private _selectedContext: PropertyCommunityInfoResultDto;

    userInfo: UserInfoResultDto;

    constructor(
        private readonly httpClient: HttpClient,
        private readonly cacheRegistrationService: MPCacheRegistrationService
    ) {}

    updateContext(val: PropertyCommunityInfoResultDto): void {
        if (JSON.stringify(val) !== JSON.stringify(this._selectedContext)) {
            this._selectedContext = val;
            this._subjectContext.next(val);
        }
    }

    getContext(): Observable<PropertyCommunityInfoResultDto> {
        return this._subjectContext;
    }

    getSelectedContext(): PropertyCommunityInfoResultDto {
        return this._selectedContext;
    }

    setSelectedContextRouteItem(val: string): void {
        this._selectedContextRouteItem = val;
    }

    getSelectedContextRouteItem(): string {
        return this._selectedContextRouteItem;
    }

    getContextInfo(baseParams: PropertyCommunityInfoParameterDto): Observable<PropertyCommunityInfoResultDto> {
        const url = `${URLConstants.ccOwnerApiBaseUrl}propertycommunityinfo${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };

        return this.httpClient
            .get<PropertyCommunityInfoResultDto>(url, options)
            .pipe(map((response) => plainToClass(PropertyCommunityInfoResultDto, response)));
    }
}
